import { RouteConfig, renderRoutes } from 'react-router-config';
import { PortalSidebarNav } from './nav';
import { Header } from '../component/header';

import styles from './index.module.scss';
import { useEffect } from 'react';
import { setTitle } from '../../lib';

import { useSelector } from 'react-redux';
import { IRootState } from '../../store/reducers';

export interface IProps {
  readonly route?: RouteConfig;
}

export const StudioEntryRouter = (props: IProps) => {
  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );

  useEffect(() => {
    setTitle('Tencent Games InGame');
  }, [selectStudio?.studioID]);

  const isExcludeMenu =
    location.pathname.startsWith('/studio/select-studio') ||
    location.pathname.includes('/fee/order-result');

  const renderPortalNav = () => {
    if (!isExcludeMenu) {
      return <PortalSidebarNav />;
    }
    return null;
  };

  return (
    <div>
      <Header
        isSmallLogo={!location.pathname.startsWith('/studio/select-studio')}
        isTransparent={!!isExcludeMenu}
      />
      <div className={styles.home}>
        {renderPortalNav()}
        {renderRoutes(props.route?.routes)}
      </div>
    </div>
  );
};
